// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2947":"11b01132","5515":"046b275e","6150":"046b275e","7125":"046b275e","7871":"937f2641"}[chunkId] + ".chunk.css";
};